<!--
 * @Copyright: Copyright (c) 2021 Yihua, All right is reserverd
 * @name: Header
 * @Description: 头部组件
 * @FilePath: /hugou-h5/src/components/NavBar.vue
 * @Version: 0.1.0
 * @Autor: hselenat
 * @Date: 2021-04-27 16:07:25
 * @LastEditors: hselenat
 * @LastEditTime: 2021-04-29 09:26:22
 * @example: 调用示例
-->
<template>
  <div class="nav-x">
    <ul>
      <li
        v-for="(item, index) in navItems"
        :key="index"
        :class="index == selectId ? 'active' : ''"
        @click="handlerLi(item, index)"
      >
        {{ item.compTitle }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      navItems: [
        {
          compName: "chat",
          compTitle: "互勾聊天"
        },
        {
          compName: "work",
          compTitle: "互勾办公"
        },
        {
          compName: "comment",
          compTitle: "互勾动态"
        },
        {
          compName: "goudrive",
          compTitle: "互勾收藏"
        }
      ],
      selectId: 0
    };
  },
  methods: {
    handlerLi(item, index) {
      this.selectId = index;
      this.$emit("handlerLi", item);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/NavBar.vue